import { generateSelectors } from "../generators/generator.selectors";
export var APPLICATION_FILTERS_SELECTORS = generateSelectors({
    entity: "ApplicationFilter",
    reducerKey: "applicationFilters",
    basePathEntity: "application-filters",
});
